/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';
import { StepData } from '@core/aem/components/run-diagnostic/interface/run-diagnostic-interface';

@Component({
  selector: 'tmo-run-diagnostic',
  templateUrl: './run-diagnostic.component.html',
})
export class RunDiagnosticTypeComponent
  extends AuthorableComponent<StepData>
  implements OnInit, OnDestroy
{
  /**
   * Stores Auth content data
   */
  public authContent: StepData;
  /**
   * Variable of Array for bulletPoints
   */
  public stepPoints: string[];

  constructor() {
    super();
  }

  public ngOnInit(): void {}

  /**
   *  method for set Data
   * @param data used to store data for the authorable aem component
   */
  public setData(data: StepData): void {
    if (this.validate(data)) {
      this.authContent = data;
    }
  }

  /**
   *  To check validation of data.
   * @param data used to store data for the authorable aem component
   */
  public validate(data: StepData): boolean {
    if (data) {
      return true;
    } else {
      throw new Error(`TemplateComponent: Invalid params ${data}, required fields: ['html']`);
    }
  }

  /**
   * Cleans component on lifecycle hook
   * @returns void
   */
  public ngOnDestroy(): void {}
}
